import { Controller } from "@hotwired/stimulus"

// Reużywalny N-stanowy switch (domyślnie 3 stany). Trzyma bieżący stan w ukrytym polu (input target),
// klik przechodzi cyklicznie do kolejnego stanu i emituje zdarzenie "change" - inny kontroler (np. wykres)
// może wtedy odczytać pole i zareagować. Stany i etykiety/kolory sterowane data-atrybutami:
//   data-tri-state-switch-states-value='["a","b","c"]'
//   data-label-<stan>="..."   data-color-<stan>="#rrggbb"
// Connects to data-controller="tri-state-switch"
export default class extends Controller {
  static targets = ["input", "track", "knob", "text"]
  static values = { states: Array }

  connect() {
    this.states = this.statesValue.length ? this.statesValue : ["off", "on"]
    // stan odtworzony z ukrytego pola (przetrwał submit), domyślnie pierwszy
    this.state = (this.hasInputTarget && this.inputTarget.value) || this.states[0]
    this.sync()
  }

  // klik - następny stan (cyklicznie), zapis do pola, odświeżenie wyglądu i emisja zmiany
  cycle() {
    const i = this.states.indexOf(this.state)
    this.state = this.states[(i + 1) % this.states.length]
    if (this.hasInputTarget) this.inputTarget.value = this.state
    this.sync()
    this.dispatch("change", { detail: { state: this.state } })
  }

  // gałka rozłożona równo po torze wg indeksu stanu; kolor toru i opis z data-atrybutów danego stanu
  sync() {
    const i = Math.max(0, this.states.indexOf(this.state))
    const n = this.states.length
    const cap = this.state.charAt(0).toUpperCase() + this.state.slice(1)

    if (this.hasKnobTarget) {
      const travel = 32 // tor 56px - gałka 20px - 2x2px margines
      this.knobTarget.style.left = `${2 + (n > 1 ? (i / (n - 1)) * travel : 0)}px`
    }
    if (this.hasTrackTarget) {
      this.trackTarget.style.backgroundColor = this.element.dataset[`color${cap}`] || "#e5e7eb"
    }
    if (this.hasTextTarget) {
      this.textTarget.textContent = this.element.dataset[`label${cap}`] || this.state
    }
  }
}
